import angular from 'angular';
 import SlidersComponent from './sliders.component';

 import SlidersT1Module from './sliders-t1/sliders-t1';

let SlidersModule = angular.module('home.sliders', [
   SlidersT1Module.name
])
   .component('sliders', SlidersComponent);

export default SlidersModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/sliders/sliders.js
 **/